import { ArrowType } from '../enums';
export function isSimpleArrow(arrow) {
    return !!arrow && arrow.arrowPositionConfiguration.arrowPositionType === ArrowType.Simple;
}
export function isTeleportArrow(arrow) {
    return !!arrow && arrow.arrowPositionConfiguration.arrowPositionType === ArrowType.Teleport;
}
export function isPolygonalArrow(arrow) {
    return !!arrow && arrow.arrowPositionConfiguration.arrowPositionType === ArrowType.Polygon;
}
export function ensureTeleportArrow(arrow) {
    if (!isTeleportArrow(arrow)) {
        throw Error('Arrow is not teleport');
    }
}
